// extracted by mini-css-extract-plugin
export var form = "styles-module--form--XI9KB";
export var controlContainer = "styles-module--controlContainer--bWL3m";
export var submit = "styles-module--submit--1qrY-";
export var agreement = "styles-module--agreement--2alkV";